import { Layout } from "antd";
import { DebtorProfile } from "features/debtorProfile";
import { DebtorSider } from "features/debtorSider";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";
import CompactModeProvider from "providers/compactModeProvider";
import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import styled from "styled-components";

const StyledLayout = styled(Layout)`
  height: 100%;
`;

function DebtorPageContent() {
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(false);

  return (
    <PageLayout>
      <DebtorSider
        isSiderCollapsed={isSiderCollapsed}
        onToggleCollapse={() => setIsSiderCollapsed((c) => !c)}
      />
      <StyledLayout>
        <DebtorProfile isSiderCollapsed={isSiderCollapsed} />
      </StyledLayout>
    </PageLayout>
  );
}

function DebtorsPage() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/accounts" />} />
      <Route
        path="/:debtorId"
        element={
          <CompactModeProvider>
            <DebtorPageContent />
          </CompactModeProvider>
        }
      />
    </Routes>
  );
}

export default DebtorsPage;
